<template>
  <el-dialog
    class="dialog-selgoods"
    title="选择商品"
    :visible.sync="isShow"
    :before-close="beforeClose"
  >
    <div class="content-page">
      <div class="bd">
        <div class="tab-header">
          <div class="header-right">
            <el-cascader
              v-model="categoryCascaderValue"
              :options="categoryCascaderOptions"
              :props="categoryCascaderProps"
              clearable
              filterable
              placeholder="请选择分类"
              size="small"
              @change="handleCategoryChange"
            ></el-cascader>
            <el-input
              placeholder="请输入商品..."
              v-model.trim="searchInput"
              class="input-search"
              size="small"
              @keyup.enter.native="searchGoods"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchGoods"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div class="tab-content">
          <div class="goods-list">
            <div class="list-title">
              <div class="title">商品</div>
              <div class="title">规格</div>
            </div>
            <el-checkbox-group v-model="checkedGoodsList" @change="checkedGoodsChange">
              <el-table :data="goodsList" style="width: 100%" :show-header="false">
                <el-table-column width="400">
                  <template slot-scope="scope">
                    <el-checkbox
                      :label="scope.row.goodsId"
                      @click="selGoodsProducts(scope.row.products, scope.$index)"
                    >
                      <div class="goods-info">
                        <el-image
                          class="pic"
                          :src="scope.row.goodsImage || defaultImg"
                          fit="fill"
                          :class="{
                            'lower-shelf': !scope.row.saleStatus,
                            'will-sell-out':
                              scope.row.totalStockCount > 1 &&
                              scope.row.totalStockCount <= 10 &&
                              scope.row.saleStatus,
                            'sell-out':
                              scope.row.totalStockCount <= 0 && scope.row.saleStatus,
                          }"
                        ></el-image>
                        <div class="info">
                          <div class="title">
                            {{ scope.row.goodsName }}
                            <div class="tag-list">
                              <span v-if="scope.row.unitType == 2">计重</span>
                            </div>
                          </div>
                          <p class="price">￥{{ scope.row.retailPrice }}</p>
                        </div>
                      </div>
                    </el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <p v-if="scope.row.products.length > 0">
                      已选规格： {{ scope.row.checkedValueContent }}
                    </p>
                    <el-link
                      v-if="scope.row.products.length > 0"
                      type="primary"
                      :underline="false"
                      @click="selGoods(scope.row)"
                      >选择</el-link
                    >
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-checkbox-group>
            <div class="list-footer">
              <el-pagination
                @current-change="handleCurrentChange"
                :page-size="queryInfo.row"
                :current-page="queryInfo.pageNo"
                background
                layout="total, prev, pager, next"
                :total="total"
              ></el-pagination>
              <el-button type="primary" size="medium" @click="confirmAdd">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog-selproducts"
      width="600px"
      title="选择规格"
      :visible.sync="dialogGoodsSpecification"
      append-to-body
    >
      <div class="content-page">
        <div class="tab-content">
          <div class="products-list">
            <div class="list-title">
              <div class="title">规格</div>
              <div class="title">价格</div>
            </div>
            <el-checkbox-group v-model="checkProductsList" @change="checkProductsChange">
              <el-table :data="productsList" style="width: 100%" :show-header="false">
                <el-table-column>
                  <template slot-scope="scope">
                    <el-checkbox :label="scope.row.productId">
                      <div class="goods-info">
                        <div class="info">
                          <div class="title">
                            {{ scope.row.valueContent }}
                          </div>
                        </div>
                      </div>
                    </el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    {{ scope.row.retailPrice }}
                  </template>
                </el-table-column>
              </el-table>
            </el-checkbox-group>
            <div class="list-footer">
              <div style="margin-top: 15px">
                <el-button type="primary" @click="selProductsConfirm">确定</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  getEdcShopGoodsCategorys,
  getFindAllGoodsPlus,
  findGoodsNum,
} from "../api/index";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  getCategoryIdFromCascader,
  loadSecondaryCategoryForCascader,
  toCategoryCascaderOptions,
} from "@/utils/secondaryCategory";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categoryCascaderOptions: [],
      categoryCascaderValue: [],
      goodsList: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      status: "",
      goodsCategoryId: "",
      checkedGoodsList: [],
      checkArr: [],
      dialogGoodsSpecification: false,
      checkProductsList: [],
      productsList: [],
      checkedList: [],
      confirmList: {},
      searchInput: "",
      defaultImg: require("../assets/img/common/default-img.jpg"),
    };
  },
  computed: {
    categoryCascaderProps() {
      return {
        checkStrictly: true,
        emitPath: true,
        lazy: true,
        lazyLoad: this.loadCategoryCascader,
      };
    },
  },
  mounted() {
    this.getEdcShopGoodsCategorys();
  },
  methods: {
    // 确定
    confirmAdd() {
      console.log(this.checkArr, "checkArr");
      console.log(this.checkedList, "checkedList");
      if (this.checkArr[0].products.length >= 1) {
        if (this.checkedList.length <= 0) {
          this.$notify({
            title: "提示",
            message: "请选择商品的规格",
            type: "warning",
            duration: 1000,
          });
          return;
        }
      }
      this.confirmList = {
        goodsName: this.checkArr[0].goodsName,
        goodsImage: this.checkArr[0].goodsImage,
        valueContent:
          this.checkedList.length >= 1
            ? this.checkedList[0].valueContent
            : this.checkArr[0].valueContent || "",
        retailPrice:
          this.checkedList.length >= 1
            ? this.checkedList[0].retailPrice
            : this.checkArr[0].retailPrice,
        memberPrice:
          this.checkedList.length >= 1
            ? this.checkedList[0].memberPrice
            : this.checkArr[0].memberPrice,
        goodsId:
          this.checkedList.length >= 1
            ? this.checkedList[0].goodsId
            : this.checkArr[0].goodsId,
        productId:
          this.checkedList.length >= 1
            ? this.checkedList[0].productId
            : this.checkArr[0].productId || "",
        unit: this.checkArr[0].unit || "",
        totalStockCount: this.checkArr[0].totalStockCount,
      };
      console.log(this.confirmList, "confirmList");
      this.$emit("confirmSelGoods", this.confirmList);

      // 清空选择的商品
      this.checkedGoodsList = [];
    },
    // 选择规格
    selGoods(item) {
      console.log(this.checkArr, "checkArr");
      console.log(item, "item");
      if (this.checkArr.length <= 0) {
        this.checkArr.push(item);
      }
      if (this.checkArr[0].goodsId == item.products[0].goodsId) {
        this.productsList = item.products;
        this.dialogGoodsSpecification = true;
      } else {
        this.$notify({
          title: "提示",
          message: "请选择对应的商品",
          type: "warning",
          duration: 1000,
        });
      }
    },
    selGoodsProducts(item, index) {
      console.log(item, index);
    },
    // 分类列表
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        pageNo: 1,
        row: 100,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.categoryCascaderOptions = toCategoryCascaderOptions(res.data);
          this.getFindAllGoodsPlus();
        } else {
          this.categoryCascaderOptions = [];
        }
      });
    },
    // 商品列表
    getFindAllGoodsPlus(goodsCategoryId = this.goodsCategoryId) {
      getFindAllGoodsPlus({
        saleStatus: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        goodsName: this.searchInput,
        goodsCategoryId: goodsCategoryId,
      }).then((res) => {
        findGoodsNum({
          saleStatus: 1,
          pageNo: this.queryInfo.pageNo,
          row: this.queryInfo.row,
          goodsName: this.searchInput,
          goodsCategoryId: goodsCategoryId,
        }).then((res) => {
          if (res.code == 1) {
            this.total = res.data;
          } else {
            this.total = 0;
          }
        });
        if (res.code == 1) {
          this.goodsList = res.data;
          this.goodsList.forEach((item) => {
            this.$set(item, "checkedValueContent", "");
          });
        } else {
          this.goodsList = [];
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getFindAllGoodsPlus();
      } else {
        this.getFindAllGoodsPlus();
      }
    },
    searchGoods() {
      this.queryInfo.pageNo = 1;
      this.getFindAllGoodsPlus(this.goodsCategoryId);
      this.status = 1;
    },
    checkedGoodsChange(value) {
      // console.log(this.confirmList, "this.confirmList")
      if (this.confirmList.goodsId) {
        var index = this.goodsList.findIndex((item) => {
          return item.goodsId == this.confirmList.goodsId;
        });
        if (index !== -1) {
          this.$set(this.goodsList[index], "checkedValueContent", "");
          this.confirmList = {};
        }
      }
      // console.log(value, "选中的商品id")
      let checkedCount = value.length;
      let newArr = [];
      if (checkedCount > 1) {
        value.splice(0, 1);
        // console.log(value, "选中的商品id")
        newArr = this.goodsList.filter((item) => {
          return item.goodsId == value[0];
        });
        // console.log(newArr, 123)
      } else {
        newArr = this.goodsList.filter((item) => {
          return item.goodsId == value[0];
        });
        // console.log(newArr, 456)
      }
      this.checkArr = newArr;
      console.log(this.checkArr, 789);
      if (this.checkArr[0].products && this.checkArr[0].products.length >= 1) {
        this.productsList = this.checkArr[0].products;
        this.dialogGoodsSpecification = true;
      }
    },
    selProductsConfirm() {
      console.log(this.checkProductsList, "checkProductsList");
      // console.log(this.checkArr, "checkArr")
      // console.log(this.checkedList, "checkedList")
      this.dialogGoodsSpecification = false;
      if (this.checkProductsList.length <= 0) {
        this.goodsList.forEach((item) => {
          this.$set(item, "checkedValueContent", "");
        });
        return;
      }
      var index = this.goodsList.findIndex((item) => {
        return item.goodsId == this.checkedList[0].goodsId;
      });
      console.log(index);
      this.checkedGoodsList = [];
      if (index !== -1) {
        this.$set(
          this.goodsList[index],
          "checkedValueContent",
          this.checkedList[0].valueContent
        );
        this.checkedGoodsList.push(this.goodsList[index].goodsId);
      }
    },
    checkProductsChange(value) {
      console.log(value);
      let count = value.length;
      let newArr = [];
      if (count > 1) {
        value.splice(0, 1);
        // console.log(value, "选中的商品id")
        newArr = this.checkArr[0].products.filter((item) => {
          return item.productId == value[0];
        });
        // console.log(newArr, 123)
      } else {
        newArr = this.checkArr[0].products.filter((item) => {
          return item.productId == value[0];
        });
        // console.log(newArr, 456)
      }
      this.checkedList = newArr;
      // console.log(this.checkedList, "checkedList")
    },
    loadCategoryCascader(node, resolve) {
      loadSecondaryCategoryForCascader(node, resolve, 100);
    },
    handleCategoryChange(value) {
      this.goodsCategoryId = getCategoryIdFromCascader(value);
      this.queryInfo.pageNo = 1;
      this.getFindAllGoodsPlus(this.goodsCategoryId);
    },
    beforeClose() {
      this.$emit("hideSelGoods");
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-selgoods {
  .content-page {
    overflow: hidden;
    .bd {
      height: 100%;
      &.sort {
        height: 100%;
        overflow-y: scroll;
        .tab-header {
          background: #fffcf5;
          border-bottom-color: #f2e7b8;
        }
        .tab-content {
          .goods-list {
            width: 100%;
          }
        }
      }
    }
    .tab-header {
      .header-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .el-cascader {
          width: 240px;
          margin-right: 10px;
        }
      }
      .btn-group-one {
        .upload-xls {
          display: inline-block;
          margin: 0 15px;
        }
      }
      .btn-group-two {
        .el-checkbox {
          margin-right: 15px;
        }
      }
    }
    .tab-content {
      padding: 0;
      height: 500px;
    }
    .tab-footer {
      text-align: center;
      margin: 10px 0;
      .el-button {
        margin-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
    }
    .goods-list {
      width: 100%;
      min-width: 100%;
      box-sizing: border-box;
      .list-title {
        display: flex;
        padding: 0 20px 0 0;
        line-height: 40px;
        background: #f8f8f8;
        .title {
          box-sizing: border-box;
          padding-left: 10px;
          flex: 1;
          &:first-of-type {
            min-width: 400px;
            max-width: 400px;
            padding-left: 40px;
          }
        }
      }
      .el-checkbox-group {
        height: calc(100% - 96px);
        overflow: auto;
      }
      .search-header {
        line-height: 30px;
        margin: 10px 0;
        font-size: 14px;
        color: #333;
        padding-left: 10px;
        .el-link {
          vertical-align: top;
          line-height: 30px;
          margin-left: 20px;
        }
      }
      &.screen {
        width: 100%;
      }
      .list-footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 15px 0 0 10px;
      }
      .goods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
      }
      .goods-info {
        display: flex;
        &.active {
          background: #f5f7fa;
        }
        .pic {
          position: relative;
          width: 50px;
          height: 50px;
          border-radius: 4px;
          &::before {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            line-height: 50px;
            font-size: 12px;
          }
          &.lower-shelf {
            &::before {
              content: "已下架";
            }
          }
          &.sell-out {
            &::before {
              content: "已售罄";
            }
          }
          &.will-sell-out {
            &::before {
              content: "将售罄";
            }
          }
        }
        .info {
          margin-left: 15px;
          .title {
            font-size: 14px;
            line-height: 28px;
            color: #666666;
            .tag-list {
              display: inline-block;
              & > span {
                background: #ee3030;
                color: #fff;
                font-size: 12px;
                border-radius: 3px;
                padding: 0 5px;
              }
            }
          }
          .price {
            font-size: 14px;
            line-height: 22px;
            color: #ee3030;
          }
        }
      }
      .table-action {
        & > span {
          margin: 0 10px;
        }
      }
      .list-none {
        text-align: center;
        font-size: 14px;
        color: #999999;
        padding-top: 200px;
        & > p {
          margin: 10px 0;
        }
      }
    }
  }
}
.dialog-selproducts {
  .content-page {
    .tab-content {
      padding: 0;
      .products-list {
        width: 100%;
        .list-title {
          display: flex;
          padding: 0 20px 0 0;
          line-height: 40px;
          background: #f8f8f8;
          .title {
            box-sizing: border-box;
            padding-left: 10px;
            flex: 1;
          }
        }
        .list-footer {
          .el-button {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
